import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Field } from 'kts-scaffold-framework/utils/doc';
import GroupButton from 'kts-platform-frame/display/components/GroupButton';
import { withRouter } from 'kts-platform-frame/routes';
import { Spin, Table, Modal, Pagination, Row, Col} from 'antd';
import BillModelData from '../ModelData';

const { unitCode } = BillModelData;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { loadingUrls } = this.props;
        const documentInfo = this.modulesState.documentInfo;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            width: '5%',
            render: (text, record, index) => {
                let indexNumber = index + 1 + ((this.modulesState.pageNum - 1) * this.modulesState.pageSize);
                return (<span> {indexNumber > 9 ? indexNumber : '0' + indexNumber}</span>);
            },
        }, {
            title: '采购商品编号',
            dataIndex: 'BuyersItemIdentification',
            width: '15%',
            render: (text, record, index) => {
                return (<span> {record.BuyersItemIdentification}</span>);
            },
        }, {
            title: '采购商品名称',
            dataIndex: 'BuyersItemName',
            width: '15%',
            render: (text, record, index) => {
                return (<span> {record.BuyersItemName}</span>);
            },
        }, {
            title: '采购规格/型号',
            dataIndex: 'BuyersItemModelName',
            width: '15%',
            render: (text, record, index) => {
                return (<span> {record.BuyersItemModelName}</span>);
            },
        }, {
            title: '数量',
            dataIndex: 'QuantityValue',
            width: '8%',
            render: (text, record, index) => {
                return (<span> {record.Quantity}</span>);
            },
        }, {
            title: '单位',
            dataIndex: 'UnitCode',
            width: '6%',
            render: (text, record, index) => {
                return (<span> {unitCode[record.UnitCode]}</span>);
            },
        }, {
            title: '不含税单价',
            dataIndex: 'Price',
            width: '9%',
            render: (text, record, index) => {
                return (<span> {record.Price}</span>);
            },
        }, {
            title: '价格单位数量',
            dataIndex: 'BaseQuantity',
            width: '10%',
            render: (text, record, index) => {
                return (<span> {record.BaseQuantity}</span>);
            },
        }, {
            title: '税率',
            dataIndex: 'TaxRate',
            width: '7%',
            render: (text, record, index) => {
                let rate = !isNaN(record.TaxRate) ? Number(record.TaxRate) * 100 : 0;
                return (<span> {rate + '%'}</span>);
            },
        }, {
            title: '含税小计',
            dataIndex: 'LineExtensionAmount',
            width: '10%',
            render: (text, record, index) => {
                return (<span> {record.LineExtensionAmount}</span>);
            },
        }];

        return (
            <div>
                <div className={css.table}>
                    <Table
                        rowKey={(record: any,index: any) => {return index + ((this.modulesState.pageNum-1) * this.modulesState.pageSize);} }
                        dataSource={this.modulesState.tableList}
                        columns={columns}
                        size="small"
                        // className="kts-app-ant-table ui-list"
                        pagination={false}
                        expandIconAsCell={false}
                        expandIconColumnIndex={-1}
                        expandRowByClick={false}
                        defaultExpandAllRows={true}
                        expandedRowKeys={ModulesAction.getRowKey()}
                        expandedRowRender={record =>
                            <div>
                                <Row>
                                    <Col offset={1} span={23}>
                                        <Row gutter={12}>
                                            {ModulesAction.getTableExtraDefaultTemplate(record, 8)}
                                            {ModulesAction.getTableExtraTemplate(record, 8)}
                                        </Row>
                                    </Col>
                                </Row>
                            </div>}
                    />
                </div>
                <div className={css.pagins}>
                    {
                    (this.modulesState.pageSize < this.modulesState.total) &&
                    <Pagination
                        style={{ display: 'inline-block' }}
                        showSizeChanger={true}
                        size="small"
                        showQuickJumper={true}
                        defaultCurrent={this.modulesState.pageNum}
                        current={this.modulesState.pageNum}
                        total={this.modulesState.total}
                        onChange={ModulesAction.pageSet}
                        onShowSizeChange={ModulesAction.pageSet}
                        pageSize={this.modulesState.pageSize}
                        showTotal={this.showTotal}
                    />
                    }
                    <p className={css.total}>总计： {documentInfo.Total}</p>
                </div>
            </div>
        );
    }
    /**
     * show总条数
     */
    private showTotal = (total: number) => {
        return `共 ${total} 条`;
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/UI.OrderBillTable.tsx